export default {
  0: 'Generated',
  1: 'Sent',
  2: 'Paid',
  3: 'Rolled Back'
}
